import { RechargePhonePage } from './recharge-phone.page';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InsertNumberComponent } from './insert-number/insert-number.component';
import { RechargeResumeComponent } from './recharge-resume/recharge-resume.component';
import { RechargeValueComponent } from './recharge-value/recharge-value.component';


const routes: Routes = [


  {
    path: '',
    component: RechargePhonePage,
    children: [
      {
        path: 'phone-number',
        component: InsertNumberComponent
      },
      {
        path: 'recharge-value',
        component: RechargeValueComponent
      },
      {
        path: 'recharge-resume',
        component: RechargeResumeComponent
      }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RechargePhoneRoutingModule { }
